module.exports = __webpack_public_path__ + "static/media/Banner.0917ccce.png";